import { number, object, string } from "zod/v4";

export const getProductReviewsRating = {
  input: string(),
  output: object({ rating: number(), numReviews: number() }).nullable(),
};
